import React from 'react';
import { ColumnHeader } from './ColumnHeader';
import { ColumnBody } from './ColumnBody';
import { PublicNoticeAuction } from '../types';

interface PostDateColumnProps {
    auction: PublicNoticeAuction;
}

export function PostDateColumn({ auction }: PostDateColumnProps) {

    const created_date = auction.auction_created_date;

    return (
        <>
            <ColumnHeader>Post Date</ColumnHeader>
            <ColumnBody>
                <div>{created_date.user.date_formatted}</div>
            </ColumnBody>
        </>
    );
}
